import { render, staticRenderFns } from "./POSSale.vue?vue&type=template&id=464d34da&scoped=true"
import script from "./POSSale.vue?vue&type=script&lang=js"
export * from "./POSSale.vue?vue&type=script&lang=js"
import style0 from "./POSSale.vue?vue&type=style&index=0&id=464d34da&prod&lang=scss&scoped=true"
import style1 from "./POSSale.vue?vue&type=style&index=1&id=464d34da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464d34da",
  null
  
)

export default component.exports